import { render, staticRenderFns } from "./CInput.vue?vue&type=template&id=4e5ca376&scoped=true"
import script from "./CInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./CInput.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CInput.vue?vue&type=style&index=0&id=4e5ca376&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5ca376",
  null
  
)

export default component.exports